<template>
  <div class="main">
    <div class="header">
      <div class="header_title">
        <div class="header_title_one">{{format.companyName}}</div>
        <div class="header_title_right" v-if="format.statusName =='重点关注中'">{{format.statusName}}</div>
        <div class="header_title_right1" v-if="format.statusName == '黑名单'">{{format.statusName}}</div>
        <div class="header_title_right2" v-if="format.statusName == '已退出'">{{format.statusName}}</div>
      </div>
      <div class="header_text">
        <div class="header_left">
          <span>{{format.time}}</span>
          <span>{{format.diffDay}}</span>
        </div>
      </div>

      <div class="header_btn" v-if="false">
          <!-- v-if="((format.status === 20 && format.isExpire &&　(userList.integrityCityGeneral || userList.integrityCountyGeneral)) || (format.status === 20 && (userList.integrityCountyLeader || userList.integrityCityLeader))) && isFromTravel != 1"
           -->
        <div
            v-if="adminIsExit || normalIsExit"
            @click="WithdrawalRegulation"
            class="header_btn_out"
        >退出重点关注</div>
        <div
          @click="toPageBlacklList"
          class="header_btn_add"
          v-if="(format.status === 20 && format.isExpire) && isFromTravel != 1"
        >纳入黑名单</div>
      </div>
      
      <div class="header_btn" v-if="format.status !== 50 && format.businessStatus == 10">
        <div class="addInformation" @click="addData" v-if="(format.status === 20 || format.status === 30 ) && isFromTravel != 1 && isShowBtn">+ 整改资料</div>
        <div
            @click="editRegulation"
            class="header_btn_out_det"
            v-if="normalIsExit"
        >退出重点关注申请</div>
        <div
            @click="WithdrawalRegulation"
            v-if="adminIsExit"
            class="header_btn_out"
        >退出重点关注</div>
      </div>
    </div>
    <div class="centerCount">
      <div class="countHeader">
        <div :class="{line_right:countType !=='', lineTop:countType===1}" @click="suitType(1)">
          <span>当前诚信指数</span>
          <span class="left leftFont">{{format.score}}</span>
          <span class="left">分</span>
        </div>
        <div :class="{lineTop:countType===2}" @click="suitType(2)">
          <span>纳入评分</span>
          <span class="right leftFont">{{format.enteredScore ? format.enteredScore.score : ''}}</span>
          <span class="right">分</span>
        </div>
      </div>
      <div class="countContent" v-if="countType === 1">
        <div>
          <span>规范指数：</span>
          <span>{{format.standardScore}}</span>
        </div>
        <div>
          <span>品质指数：</span>
          <span>{{format.qualityScore}}</span>
        </div>
        <div>
          <span>体验指数：</span>
          <span>{{format.experienceScore}}</span>
        </div>
      </div>
      <div class="countContent" v-if="countType === 2">
        <div>
          <span>规范指数：</span>
          <span>{{ format.enteredScore ? format.enteredScore.standardScore : '' }}</span>
        </div>
        <div>
          <span>品质指数：</span>
          <span>{{ format.enteredScore ? format.enteredScore.qualityScore : '' }}</span>
        </div>
        <div>
          <span>体验指数：</span>
          <span>{{ format.enteredScore ? format.enteredScore.experienceScore : '' }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_view">
        <div class="content_text">
          <div class="content_text-header">
            <span>{{statusTypeName}}</span>
          </div>
          <!-- <div
            @click="addData"
            v-if="format.status === 20 && isFromTravel != 1 && isShowBtn"
            class="addInformation"
          >+整改资料</div> -->
          <div class="content_text-center" v-if="!isShowBtn">
            <div>暂无整改明细~</div>
            <div class="center_btn" v-if="format.businessStatus == 10" @click="addData">+整改资料</div>
          </div>

          <!-- <div class="loading"  v-if="!isShowBtn">
            <van-loading type="spinner" vertical='true' />
          </div>-->

          <div class="content_text-centers" v-for="(item, index) in dataList" :key="index">
            <div class="centers_content" v-if="dataList.length>0">
              <ul>
                <li>
                  <div class="content_left"></div>
                  <div class="content_right">
                    <div class="itemBox">
                      <p v-show="item.status!=80">{{item.statusName}}</p>
                      <p v-show="item.status==80">
                        {{item.statusName}}:
                        <span class="p_span">{{item.score}}</span>
                      </p>
                    </div>
                    <p class="time" v-show="item.createTime">{{item.createTime | filtTime}}</p>
                    <div class="taskItem">
                      <div class="title">执法人员：</div>
                      <div class="item">{{item.creatorName}}</div>
                    </div>
                    <div class="taskItem" v-show="item.taskName">
                      <div class="title">任务名称：</div>
                      <div class="item">{{item.taskName || '无' }}</div>
                    </div>
                    <div class="taskItem" v-if="item.content">
                      <div class="title">备注说明：</div>
                      <div class="item">{{item.content}}</div>
                    </div>
                    <div class="fileBox" v-if="item.attachListItem && item.attachListItem.length">
                      <div class="fileTitle">整改方案附件：</div>
                      <!-- <better-scroll
                        class="imgList"
                        :scrollX="true"
                        v-if="item.attachListItem && item.attachListItem.length"
                      >
                        <div class="warp" v-if="item.attachListItem && item.attachListItem.length">
                          <img
                            :src="value"
                            @click="showViewer(index, $event, item.attachListItem)"
                            v-for="(value, index) in item.attachListItem"
                            :key="index"
                          />
                        </div>
                      </better-scroll> -->
                    </div>
                    <better-scroll class="file_img" :scrollX="true" v-if="item.attachListItem && item.attachListItem.length">
                         <div class="file_wrapper">
                              <img
                                  :src="value"
                                  @click="showViewer(index, $event, item.attachListItem)"
                                  v-for="(value, index) in item.attachListItem"
                                  :key="index"
                                />
                              </div>
                    </better-scroll>
                    <div class="detailColor" v-show="item.status==80 || item.status == 30 || item.status == 31 || item.status == 32" @click="showMore(item)">
                      查看详情
                      <img src="../../../../assets/integrity/ic_xl@3x.png" alt />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 纳入黑名单失败时的弹框 -->
    <editDialog :title="title" :content="content" :show="isBtnShow" @hideDialog="hideDialog"></editDialog>
  </div>
</template>
<script>
    import betterScroll from '../../../../components/base/betterScroll';
    import editDialog from '../../components/editDialog.vue';
    import api from '../../../../service/modules/integrity';
    export default {
        components: {
            editDialog,
            'better-scroll': betterScroll
        },
        data () {
            return {
                adminIsExit: false, // 后台返回权限字段 重点关注按钮
                normalIsExit: false, // 后台返回权限字段 重点关注按钮
                isShowBtn: false,
                // imgList: [], // 图片信息
                format: {}, // 企业信息
                statusTypeName: '',
                dataList: [], // 监管整改明细列表
                isShow: true,
                cosKey: '', // 预览图片参数
                isBtnShow: false,
                title: '',
                num: '0',
                content: '',
                showAddData: true, // 是否展示添加资料
                enterpriseId: '', // 重点关注id,
                logId: '', // 登录Id
                isExpire: '', // 是否出现重点关注按钮
                userList: JSON.parse(localStorage.getItem('integrityInfo')),
                isFromTravel: this.$router.currentRoute.query.isFromTravel,
                countType: ''
            };
        },
        created () {
            // console.log(this.$router.currentRoute.query.isFromTravel);
            if (this.$route.query.name === 'uploadFile') {
                this.$Toast.success({
                    message: '上传成功',
                    forbidClick: true
                });
            }
            this.enterpriseId = this.$route.query.enterpriseId;
            this.supervisionId = this.$route.query.supervisionId;
            this.handleList();
            this.getSupervisionTaskInfo();
            this.suitType(1);
        },
        methods: {
            suitType (val) {
                this.countType = val;
            },
            // 查看详情
            showMore (item) {
                if (item.status === 80) {
                    this.$router.push({
                        path: 'workOrder',
                        query: { enterpriseId: item.workOrderId }
                    });
                } else {
                    this.$router.push({
                        path: '/integrity/applicationDetele',
                        query: {
                            taskId: item.taskId,
                            showType: false,
                            type: item.status === 32 ? '2' : item.status === 30 ? '0': '1',
                            title: this.format.companyName
                        }
                    });
                }
            },
            // 图片预览
            showViewer (index, event, imgList) {
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:imgList|| [],
                    index
                  },
                })

                // this.$ImagePreview({
                //     images: imgList,
                //     startPosition: index,
                //     closeOnPopstate: true
                // });
            },
            // 黑名单 重点关注
            getSupervisionTaskInfo () {
                api.supervisionTaskInfo({ enterpriseId: this.enterpriseId }).then(res => {
                    if (res.ret === 0) {
                        this.format = res.data;
                        this.adminIsExit = res.data.adminIsExit
                        this.normalIsExit = res.data.normalIsExit
                        // 如果是区县管理员，可以显示该按钮
                        if (res.data.status === 20) {
                            // 进入重点关注
                            this.statusTypeName = '监管整改明细';
                        } else if (res.data.status === 40) {
                            // 退出重点关注
                            this.statusTypeName = '监管记录';
                        } else if (res.data.status === 50) {
                            // 纳入黑名单
                            this.statusTypeName = '监管记录';
                        }
                    }
                });
            },
            // 查询重点关注详情
            handleList () {
                let parm = {
                    supervisionId: this.supervisionId
                };
                api.getSupervisionLog(parm).then(res => {
                    if (res.ret === 0) {
                        if (res.data && res.data.length) {
                            res.data[0].addType = true;
                            let data = res.data;
                            for (var i = 0; i < data.length; i++) {
                                data[i].attachListItem = [];
                                if (data[i].attachList && data[i].attachList.length) {
                                    for (var j = 0; j < data[i].attachList.length; j++) {
                                        data[i].attachListItem[j] = data[i].attachList[j].url;
                                    }
                                }
                            }
                            this.dataList = data;
                            if (this.dataList.length === 0) {
                                this.isShowBtn = false;
                            } else {
                                this.isShowBtn = true;
                            }
                        }
                    }
                });
            },
            hideDialog () {
                this.isBtnShow = false;
            },
            // 纳入黑名单
            toPageBlacklList () {
                api.checkBlacklist({ supervisionId: this.supervisionId }).then(res => {
                    if (res.ret === 0) {
                        if (res.data === 1) {
                            this.isBtnShow = true;
                            this.title = '纳入失败';
                            this.content = res.msg;
                        } else {
                            this.$router.replace({
                                path: 'blackList',
                                query: {
                                    enterpriseId: this.enterpriseId,
                                    supervisionId: this.supervisionId
                                }
                            });
                        }
                    }
                });
            },

            /** 退出重点关注申请 */
            editRegulation () {
                api.checkSupervision({ supervisionId: this.supervisionId }).then(res => {
                    if (res.ret === 0 && res.data === 1) {
                        this.isBtnShow = true;
                        this.title = '退出失败';
                        this.content = res.msg;
                    } else {
                        this.$router.push({
                            path: '/integrity/editRegulation', // 退出重点关注
                            query: {
                                enterpriseId: this.enterpriseId,
                                supervisionId: this.supervisionId
                            }
                        })
                    }
                })
            },
            // 退出重点关注
            WithdrawalRegulation () {
                if (this.format.score > 6) {
                    this.$router.push({
                        path: 'uploadData', // 退出重点关注
                        query: {
                            enterpriseId: this.enterpriseId,
                            supervisionId: this.supervisionId
                        }
                    })
                } else {
                    this.isBtnShow = true;
                    this.title = '退出失败';
                    this.content = '当前企业诚信指数<6分，无法退出重点关注名单';
                }
            },
            // 整改资料
            addData () {
                this.$router.push({
                    path: 'uploadFile',
                    query: {
                        enterpriseId: this.enterpriseId,
                        supervisionId: this.supervisionId
                    }
                });
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    };
</script>
<style lang="less" scoped>
.main {
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;
  min-height: 100%;
  padding: 20px 16px;
  .header {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 14px 16px 8px 16px;
    .header_title {
      overflow: hidden;
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      .header_title_one {
        line-height: 24px;
        width: 65%;
        float: left;
        font-weight: 600;
      }
      .header_title_right {
        overflow: hidden;
        float: left;
        width: 30%;
        line-height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 140, 25, 1);
        text-align: right;
      }
      .header_title_right1 {
        overflow: hidden;
        float: left;
        width: 30%;
        line-height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #ff4d4d;
        text-align: right;
      }
      .header_title_right2 {
        overflow: hidden;
        float: left;
        width: 35%;
        line-height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        text-align: right;
      }
    }
    .header_text {
      overflow: hidden;
      // margin-bottom: 12px;
      .header_left {
        width: 70%;
        color: #666666;
        span {
          display: inline-block;
          // height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          // line-height: 20px;
          white-space: nowrap;
          margin-top: 13px;
        }
      }
    }
    .header_btn {
      display: flex;
      color: #fff;
      line-height: 28px;
      text-align: center;
      margin-top: 12px;
      font-size: 12px;
      .addInformation {
        background: rgba(54, 179, 116, 1);
        line-height: 28px;
        width: 76px;
        font-size: 12px;
        color: #fff;
        text-align: center;
        border-radius: 1px;
        margin-right: 12px;
      }
      .header_btn_out {
        border-radius: 1px;
        background: rgba(255, 140, 25, 1);
        width: 88px;
        height: 28px;
        margin-right: 12px;
      }
      .header_btn_out_det {
        border-radius: 1px;
        background: rgba(255, 140, 25, 1);
        width: 112px;
        height: 28px;
        margin-right: 12px;
      }
      // .header_btn_add {
      //   border-radius: 1px;
      //   background: rgba(255, 77, 77, 1);
      //   width: 88px;
      //   height: 28px;
      //   margin-right: 12px;
      // }
    }
  }
  .centerCount {
    width:100%;
    height:92px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-top: 16px;
    .countHeader {
      display: flex;
      height: 50%;
      .leftFont {
        font-weight:bold;
      }
      div {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content:center;
        span:nth-child(1) {
          font-size: 14px;
          color:#333333;
        }
        span:nth-child(2) {
          margin-left: 8px;
          line-height: 30px;
        }
        .left {
          font-size: 20px;
          color: #36B374;
        }
        .right {
          font-size: 20px;
          color: #FF4D4D;
        }
        span:nth-child(3) {
          margin-left: 8px;
          font-size: 10px;
          margin-top: 4px;
        }
      }
      .lineTop {
        border-top: 2px solid #36B374;
        border-radius: 3px;
      }
    }
    .countContent {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 50%;
      div>span:nth-child(1) {
        color:#999999;
      }
    }
  }
  .content {
    margin-top: 10px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    height: 100%;
    widows: 100%;
    .content_view {
      width: 100%;
      height: 100%;
      .content_text {
        padding: 0 16px;
        .addInformation {
          margin-top: 16px;
          background: rgba(54, 179, 116, 1);
          line-height: 28px;
          width: 76px;
          font-size: 12px;
          color: #fff;
          text-align: center;
          border-radius: 1px;
        }
        .content_text-header {
          padding-top: 16px;
          span {
            font-size: 14px;
            font-weight: 600;
            line-height: 14px;
            color: #333333;
          }
        }
        .content_text-center {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 400px;
          .center_btn {
            background: #36b374;
            color: #fff;
            font-size: 14px;
            height: 30px;
            width: 100px;
            border-radius: 5px;
            text-align: center;
            line-height: 30px;
            margin-top: 10px;
          }
        }
        .content_text-centers {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          padding-bottom: 10px;
          border-bottom: 1px solid #eeeeee;
          .centers_header {
            text-align: center;
            .center_btn {
              background: #36b374;
              color: #fff;
              font-size: 14px;
              height: 30px;
              width: 100px;
              border-radius: 5px;
              text-align: center;
              line-height: 30px;
              margin-top: 10px;
            }
          }
          .centers_content {
            width: 100%;
            height: 100%;
            margin-top: 20px;
            ul {
              list-style: none;
              li {
                display: flex;
                font-size: 16px;
                position: relative;
                .content_left {
                  background: #36b374;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  position: absolute;
                  top: 4px;
                }
                .content_right {
                  margin-left: 10px;
                  padding-left: 8px;
                  width: 100%;
                  height: 100%;
                  .time {
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    margin-top: 12px;
                    margin-bottom: 8px;
                  }
                  .itemBox {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 14px;
                    line-height: 14px;
                    > p:first-child {
                      font-weight: bold;
                    }
                    > p:nth-child(2) {
                      font-size: 14px;
                      color: #666;
                    }
                    span {
                      display: inline-block;
                      color: #36b374;
                    }
                  }

                  .taskItem {
                    font-size: 14px;
                    color: #666;
                    margin: 8px 0;
                    .title {
                      float: left;
                      font-size: 12px;
                      font-weight: 400;
                      color: rgba(51, 51, 51, 1);
                    }
                    .item {
                      width: 250px;
                      font-size: 12px;
                      font-weight: 400;
                      color: rgba(51, 51, 51, 1);
                    }
                  }
                  .fileBox {
                    margin: 8px 0;
                    font-size: 14px;
                    .fileTitle {
                      margin: 8px 0;
                      font-size: 14px;
                      font-weight: 400;
                      color: rgba(51, 51, 51, 1);
                      margin-top: 12px;
                    }
                    .imgBox {
                      height: 100px;
                      .imgItem {
                        width: 100px;
                        height: 100px;
                        float: left;
                        img {
                          display: inline-block;
                          height: 100px;
                        }
                      }
                    }
                    .imgList {
                      width: 100%;
                      height: 80px;
                      overflow: hidden;
                      position: relative;
                      .warp {
                        white-space: nowrap;
                        position: absolute;
                        img {
                          width: 80px;
                          height: 80px;
                          display: inline-block;
                          margin-right: 10px;
                        }
                      }
                    }
                  }
                  .detailColor {
                    margin-top: 4px;
                    color: #36b374;
                    font-size: 12px;
                    line-height: 12px;
                    position: relative;
                    img {
                      position: absolute;
                      width: 12px;
                      height: 12px;
                      left: 50px;
                      top: 0;
                    }
                  }
                  .file_img{
                    width:100%;
                    height:80px;
                    position: relative;
                    overflow: hidden;
                    .file_wrapper{
                      height:80px;
                      white-space: nowrap;
                      position:absolute;
                      img{
                         width: 80px;
                         height: 80px;
                         display: inline-block;
                         margin-left:10px;
                         border-radius: 3px;
                      }
                      img:nth-child(1){
                        margin-left:0;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .content_text-centers:last-child {
          border: none;
        }
      }
    }
  }
}
</style>
